module.exports = __webpack_public_path__ + "static/media/image2.63706e76.jpg";